export function toYesNo(value: boolean): string {
    if (value == null) return null;

    return value
        ? "Yes"
        : "No";
}